import { RoomConnectionDescriptorDto } from '../dtos/rooms'

export type RoomConnectionDescriptor =
  | WherebyRoomConnectionDescriptor
  | LocalRoomConnectionDescriptor

export interface WherebyRoomConnectionDescriptor {
  type: 'Whereby'
  roomUrl: string
}

export interface LocalRoomConnectionDescriptor {
  type: 'Local'
}

export function mapConnectionDescriptorFromDto(
  descriptor: RoomConnectionDescriptorDto,
): RoomConnectionDescriptor {
  switch (descriptor.type) {
    case 'Whereby':
      return {
        type: 'Whereby',
        roomUrl: descriptor.room_url,
      }
    case 'Local':
      return {
        type: 'Local',
      }
  }
}
